import { ActionTypes } from "./act_types"
import { $getBusinessUnit } from "../requests"
import { getUserRole, getTranslationsByScope, DropitState } from "../reducers"
import { toastr } from "react-redux-toastr"
import { responseType, transform } from "../../utils/http-res-handler"
import { LocalStorageKeys } from "../../utils/local-storage-keys"
import { ISupplierInfo } from "../../models"
import { stringify } from "../../utils/stringifyier"

export const setRole = (role: any) => ({ type: ActionTypes.SET_ROLE, role })

export const changeSelectedSupplier = (value: ISupplierInfo) => {
  window.stop()
  localStorage.setItem(LocalStorageKeys.SELECTED_SUPPLIER, value.supplierName)
  window.location.reload()
}

export const setSelectedSupplier = (supplier: ISupplierInfo) => ({
  type: ActionTypes.SET_SELECTED_SUPPLIER,
  supplier,
})

export const setManagedSupplierList = (
  managedSupplierList: ISupplierInfo[]
) => ({
  type: ActionTypes.SET_MANAGED_SUPPLIER_LIST,
  managedSupplierList,
})

export const fetchBusinessUnit =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    const role = getUserRole(getState())

    const translations = getTranslationsByScope(getState(), "toastrLabels")

    $getBusinessUnit(role, translations)
      .then((result) => {
        dispatch({
          type: ActionTypes.SET_BUSINESS_UNIT,
          businessUnits: result,
        })
      })
      .catch((err) => {
        toastr.error(
          err.message ? err.message : "Impossible de contacter le server.",
          ""
        )
        return err
      })
  }
